import StorageKeys from "../../../const/StorageKeys";
import CacheStorage from "../../../service/storage/CacheStorage";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { BranchFollowGroupsListModel } from "../../../model/branch/BranchFollowGroupsListModel";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import ShowToast from "../../../widget/common/ui/Toast";
import { navigate } from "../../../service/navigation/Navigation";

const BranchFollowGroupsProvider = new (class BranchFollowGroupsProvider {
  navigate = (url: any) => {
    navigate(url);
  };

  getGroupsListAPI = async (): Promise<BranchFollowGroupsListModel | null> => {
    ApiUrls.init();

    const barnchId: string = CacheStorage.getValue(StorageKeys.branch_id);
    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";

    const url: string = `${ApiUrls.baseUrl}notice/follow_branch_group_list`;
    const body: any = {
      account_id: accountId,
      branch_id: barnchId,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const BranchFollowGroupsModel: BranchFollowGroupsListModel = response;
        return BranchFollowGroupsModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    } else {
      ShowToast.warning(AppTranslation.text("something_went_wrong"));
    }

    return null;
  };

  submitSelection = async (groupIds: Array<string>): Promise<boolean> => {
    ApiUrls.init();

    const barnchId: string = CacheStorage.getValue(StorageKeys.branch_id);
    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";

    const url: string = `${ApiUrls.baseUrl}notice/follow_branch_groups`;
    const body: any = {
      account_id: accountId,
      branch_id: barnchId,
      group_id: groupIds.join(","),
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    } else {
      ShowToast.warning(AppTranslation.text("something_went_wrong"));
    }

    return false;
  };
})();

export default BranchFollowGroupsProvider;
